// Version : 0.0.1
// Author : SATHISH
// LastEdit : KARTHEESWARAN
// MODFIED DATE:30-09-2025
//Last ADD : DESTRUCTURE THE PAYLOAD VALUES AND REMOVED EXCEL

import { takeLatest, put, all, call } from 'redux-saga/effects';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import { getdaybookListDetails } from './dayBookReport.services';
import {
	// GET DAYBOOK RESPONSE LIST
	getDaybookReportListFailure,
	getDaybookReportListResponseChanged,
	getDaybookReportListSuccess,
} from './daybookReport.action';
import DayBookType from './dayBookReport.types';
/** *********************  START DAY BOOK REPORT DETAILS  LIST  ******************** */
export function* daybookReportDetailsListGet({ payload }: any) {
	try {
		const key = 'GetBranchAccountDayBookKey';
		const {
			FromDate,
			ToDate,
			EntryDate,
			databaseName,
			companyID,
			infogCompanyID,
			userAccessBranchID,
		} = payload;
		const jsonData = {
			Infog_CompanyID: infogCompanyID,
			BranchID: userAccessBranchID,
			EntryDate: EntryDate,
			FromDate: FromDate,
			ToDate: ToDate,
			DatabaseName: databaseName,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getdaybookListDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getDaybookReportListFailure(responseData.data));
		} else {
			yield put(getDaybookReportListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getDaybookReportListFailure(error));
	}
}

export function* resetGetDaybookReportListResponse() {
	yield put(getDaybookReportListResponseChanged());
}

export function* onGetDaybookReportListDetails() {
	yield takeLatest(DayBookType.GET_DAYBOOK_LIST_START, daybookReportDetailsListGet);
}

export function* onGetdaybookReportListResponseReset() {
	yield takeLatest(
		DayBookType.GET_DAYBOOK_LIST_RESPONSE_RESET,
		resetGetDaybookReportListResponse,
	);
}
/** *********************  END GET  DAY BOOK REPORT DETAILS LIST ******************** */

export function* daybookReportSaga() {
	// GET DAYBOOK RESPONSE LIST
	yield all([call(onGetdaybookReportListResponseReset), call(onGetDaybookReportListDetails)]);
}
